import type { CanvasState, SliceCreator } from '../types';
import type { SliceCtx } from '../ctx';

export const createTemplatesSlice: SliceCreator<Pick<CanvasState, 'setTemplates'>> = (set, get) => {
  const resolveCtx = (): SliceCtx | undefined => (get as any).__ctx;
  return {
    setTemplates: (templates) => {
      const ctx = resolveCtx();
      ctx?.debugLog('setTemplates', { size: templates?.size });
      set((state) => {
        state.templates = templates;
      });
      ctx?.queueInference({ immediate: true });
    },
  };
};
